import React from 'react';

import necrolog from '../images/necrolog.jpg';
import gregory from '../images/gregory.jpg';
import taras from '../images/taras.jpg';
import materials from '../images/materials.jpg';
import boscohistory from '../images/boscohistory.jpg';
import office from '../images/office.jpeg';
import blog1 from '../images/blog-1.jpg';
import general from '../images/general02.png';
// @ts-ignore
import news from '../images/blog1_0.JPG';
import ugkc from '../images/blog2_2.png';
import gaslo from '../images/blog4_1.png';
import CustomizedDialogs from 'components/dialog';
import Heading from '../Heading';
import AllNews from '../components/novini/allNews';

const Novini = () => {
  return (
    <section className="pb-10">
      <div className="container">
        <Heading name="Новини" />
        {/* <AllNews /> */}
         <section className="md:pb-20">
            <div className="grid grid-cols-1 md:grid-rows-6 gap-4 md:grid-cols-3 md:max-h-[372px]">
              <a href="/zustrich-vertepiv-spilnot-molodizhnoho-saleziianskoho-rukhu" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                <p
                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини провінції
                </p>
                <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Зустріч вертепів спільнот Молодіжного Салезіянського Руху”
                </p>
                <img className="!rounded-xl object-cover w-full h-full object-top" src={news} alt="" />
                <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" />
              </a>
              <a href="/rozzbroity-nashi-sertsia-zarady-myru" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                <p

                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини Генерального Дому
                </p>
                <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Роззброїти наші серця заради миру”
                </p>
                <img className="!rounded-xl object-cover w-full h-full object-top" src={ugkc} alt="" />
                <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" />
              </a>
              <a
                href="/svyatij-ivan-bosko"
                className="group max-md:order-4 relative max-md:h-[70px] md:col-span-1 md:row-span-2"
              >
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4 text-white z-0 bg-[#A81414] h-full w-full"></div>

                <p
                  className="!rounded-lg !border-0 !normal-case font-medium !inset-x-0 top-[50%] -translate-y-[50%] !text-md md:!text-[40px] !py-1 !absolute !left-[35px] !text-white !z-10 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Хто ми
                </p>

                <img
                  className="!absolute !rounded-xl w-[44px] h-[44px] md:top-[50%] md:-translate-y-[50%] md:right-[35px] bottom-0 right-0 z-10 pointer-events-auto"
                  src="images/link-to.png"
                  alt=""
                />
              </a>
              <a
                href="/piznaj-svoye-poklikannya"
                className="group max-md:order-4 relative max-md:h-[70px] md:col-span-1 md:row-span-2"
              >
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4 text-white z-0 bg-[#A81414] h-full w-full"></div>

                <p
                  className="!rounded-lg !border-0 !normal-case font-medium !inset-x-0 top-[50%] -translate-y-[50%] !text-md md:!text-[40px] !py-1 !absolute !left-[35px] !text-white !z-10 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Покликання
                </p>
                <img
                  className="!absolute !rounded-xl w-[44px] h-[44px] md:top-[50%] md:-translate-y-[50%] md:right-[35px] bottom-0 right-0 z-10 pointer-events-auto"
                  src="images/link-to.png"
                  alt=""
                />
              </a>

               <a href="/gaslo-2026" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                {/* <p

                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини Генерального Дому
                </p> */}
                {/* <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Гасло 2026”
                </p> */}
                <img className="!rounded-xl object-cover w-full h-full object-[position:50%_-220px] md:object-[position:50%_-270px]" src={gaslo} alt="" />
                {/* <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" /> */}
              </a>
              <a href="/poslannia-heneralnoho-nastoiatelia-saleziian-na-sichen-2026" className="relative max-md:h-[200px] md:col-span-1 md:row-span-3">
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4	 text-white z-90 bg-black h-full w-full opacity-10"></div>
                <p
                  className="!rounded-tl-lg !rounded-br-lg !border-0 !normal-case !bg-[#A81414] !text-md md:!text-[20px] !py-1 !absolute !top-[0px] !left-[0px] !text-white !z-100 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  Новини Генерального Дому
                </p>
                {/* <p
                  className="!rounded-b-lg !border-0 !normal-case !bg-[#f0eded] !text-base md:!text-lg !py-1 !absolute !bottom-[0px] !left-[0px] !text-black !z-100 !w-[100%] !text-start !hover-underline-animation px-2"
                >
                  “Кошик Мами Маргарити”
                </p> */}
                <img className="!rounded-xl object-cover w-full h-full" src={general} alt="" />
                {/* <img className="absolute bottom-0 right-0 !rounded-xl object-cover object-top w-[30px] h-[30px] " src={"images/link-to.png"} alt="" /> */}


              </a>
              <a
              target="_blank"
                href="https://ugcc.ua/"
                className="group max-md:order-4 relative max-md:h-[70px] md:col-span-1 md:row-span-2"
              >
                <div className="!rounded-xl pt-1 absolute left-[50%] -translate-x-2/4 text-white z-0 bg-[#A81414] h-full w-full"></div>
                <p
                  className="!rounded-lg !border-0 !normal-case font-medium !inset-x-0 top-[50%] -translate-y-[50%] !text-md md:!text-[40px] !py-1 !absolute !left-[35px] !text-white !z-10 !w-[100%] max-w-max !text-center !hover-underline-animation px-2"
                >
                  УГКЦ
                </p>
                <img
                  className="!absolute !rounded-xl w-[44px] h-[44px] md:top-[50%] md:-translate-y-[50%] md:right-[35px] bottom-0 right-0 z-10 pointer-events-auto"
                  src="images/link-to.png"
                  alt=""
                />
              </a>
            </div>
          </section>
      </div>
    </section>
  );
};

export default Novini;
